import React from 'react';
import styled, { css } from 'styled-components';
import { getNeutralColors } from '../theme';
import { BodyText } from '../typography';

const TooltipWrapper = styled.div`
  background: ${getNeutralColors('black')};
  border-radius: 4px;
  padding: 8px 12px;
  position: absolute;
  text-align: center;
  top: -50px;
  z-index: 5;
  color: ${getNeutralColors('white')};
  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 6px solid ${getNeutralColors('black')};
    bottom: -6px;
    left: calc(50% - 4px);
  }
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}

  ${BodyText} {
    display: block
  }
`;

const Tooltip = ({ text, height = null, width = null }) => {
  return (
    <TooltipWrapper height={height} width={width}>
      <BodyText size={200}>{text}</BodyText>
    </TooltipWrapper>
  );
};

export default Tooltip;
